<div class="lcl-package-item-row">
  <div class="lcl-package-item-data" [ngClass]="{ 'w-100': !isCanDelete && !isCanEdit }">
    <div class="row align-items-center">
      <div class="d-flex col-3 col-xl-5 pr-0">
        <img [src]="isShowPallet ? 'assets/icons/icon_pallet.svg' : 'assets/icons/icon_package.svg'" class="mr-1 mr-xl-3" />

        <span class="lcl-package-item-data-name">
          <span class="mr-2">{{ package.quantity }}</span>
          <span>{{ typeName }}</span>
          <span *ngIf="isShowPallet" class="d-none d-xl-inline ml-2" [title]="palletStandard">({{ palletStandard }})</span>
        </span>
      </div>

      <div class="col-5 col-xl-4 pr-0">
        <span [title]="palletStandardMobile">
          <span class="d-xl-none ml-xl-2" *ngIf="isShowPalletStandardInput">({{ palletStandardMobile }}) X</span>
          <span *ngIf="!isShowPalletStandardInput">{{ normalizedLength }} X {{ normalizedWidth }} X</span>
          {{ normalizedHeight }} {{ lengthName }}
        </span>
      </div>

      <div class="col-2 col-xl-3 pr-0">
        <span>{{ package.weight }} {{ weightName }}</span>
        <span class="lcl-package-item-data-stackable d-none d-xl-inline" *ngIf="package.stackable">
          {{ "LABELS.STACKABLE" | translate }}
        </span>
        <span class="lcl-package-item-data-stackable d-none d-xl-inline" *ngIf="!package.stackable">
          {{ "LABELS.NON_STACKABLE" | translate }}
        </span>
      </div>

      <div class="col-2 col-xl-1 d-flex d-xl-none justify-content-end pr-0">
        <button class="btn lcl-package-item-btn-edit-form" *ngIf="isCanEdit" (click)="editPackage.emit()">
          <i class="fa fa-pencil"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="lcl-package-item-actions" *ngIf="isCanDelete">
    <button class="btn lcl-package-item-btn-edit-form" *ngIf="isCanEdit" (click)="editPackage.emit()">
      <i class="fa fa-pencil"></i>
    </button>

    <button
      class="btn lcl-package-item-btn-remove-form d-none d-xl-block"
      [disabled]="isAdminView ? false : isLastest"
      (click)="removePackage.emit()"
    >
      <i class="fa fa-trash"></i>
    </button>
  </div>
</div>
